module.exports = __webpack_public_path__ + "img/skull_13.599d5482.png";